import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getComp } from '../components/comp/comp.api';
import { useQuery } from 'react-query';
import keys from 'common/react-query/data-keys';
import { handleError } from 'common/utils/util.errors';
import { LinearProgress } from '@mui/material';
import { getDivisions } from '../components/glossary/glossary.api';
import { Box, Typography } from 'components/index';
import CompWrapper from '../components/comp/CompWrapper';

export const Comp: React.FC = () => {
  const navigate = useNavigate();
  const { compId } = useParams<{ compId: string }>();
  const {
    data: comp,
    isLoading: isLoadingComp,
    isError: isErrorComp,
    error: errorComp,
  } = useQuery([keys.comps, compId], () => getComp(compId ?? ''), {
    enabled: !!compId,
  });

  const {
    data: divisions,
    isLoading: isLoadingDivisions,
    isError: isErrorDivisions,
    error: errorDivisions,
  } = useQuery(keys.divisions, getDivisions);

  if (!compId) {
    navigate('./NotFound');
  }
  if (isErrorComp || isErrorDivisions) {
    handleError(errorComp || errorDivisions);
    if (errorComp && compId) {
      return (
        <Box display='flex' justifyContent='center' sx={{ marginTop: 4 }}>
          <Typography variant='h6' color='error'>
            Unable to Load Comp
          </Typography>
        </Box>
      );
    }
    return null;
  }
  if (isLoadingComp || isLoadingDivisions) {
    return <LinearProgress />;
  }

  if (!comp || !divisions) {
    return null;
  }

  return <CompWrapper initialComp={comp} divisions={divisions} />;
};

export default Comp;
